/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/prefer-for-of */
import React from 'react';
import '@/pages/opinion/components/UserScoreBox/index.scss';
import { formatter, listTimeTitleFunc } from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat, scoreFormat } from '@/pages/opinion/utils/value';
import { getPercentageInfo } from '@/pages/opinion/utils';
import { useHistory, useIntl } from 'umi';
import ScoreTrendCharts from '@op/pages/gamestore/components/ScoreTrendCharts';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import moment from 'moment';
import { JumpType } from '@home/utils/utils';

// 代码从舆情迁移
export default function ScoreTrendBox({
  filterParams,
  platformData,
  platform,
  height,
}: any) {
  const { formatMessage } = useIntl();
  const history = useHistory();

  return (
    <div className="dbo-scorebox">
      {/* 没有数据情况需传入nodata=true */}
      <div className="dbo-scorebox-bd">
        <div className="echart-data">
          <ScoreTrendCharts
            height={height}
            tooltipBottom = {-100}
            tooltipFormatter={(params: any) => {
              const newParams = params.filter(
                (v: any) =>
                  v.seriesType === 'bar' && v.seriesName !== 'total总数',
              ); // 过滤掉'total总数'的柱子
              const lineParams = params.filter(
                (v: any) => v.seriesType === 'line',
              );
              // 时间
              const dataTime = listTimeTitleFunc(
                newParams[0]?.axisValue,
                filterParams?.date_type,
              );

              // 计算总人数
              let totalReviews = 0;
              for (let i = 0;i < newParams.length;i++) {
                if (
                  newParams[i].seriesName != '' &&
                  newParams[i].value !== undefined &&
                  newParams[i].value !== 0
                ) {
                  totalReviews += newParams[i].value;
                }
              }

              const lineRecords: any[] = [];
              const barRecords: any[] = [];

              for (let i = 0;i < lineParams.length;i++) {
                const { marker, seriesName } = lineParams[i];
                lineRecords.push({
                  type: `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;${formatMessage(
                    { id: seriesName },
                  )}`,
                  score: scoreFormat(lineParams[i]?.value),
                });
              }

              barRecords.push({
                type: formatMessage({ id: 'Sum of Reviews' }),
                score: reviewsFormat(totalReviews),
                percentage: '100%',
              });

              for (let i = 0;i < newParams.length;i++) {
                if (
                  newParams[i].seriesName != '' &&
                  newParams[i].value !== undefined &&
                  newParams[i].value !== 0
                ) {
                  const { marker } = newParams[i];

                  barRecords.push({
                    type: `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;<span class="tooltip-star tooltip-star-${newParams[i].seriesName[0]}"></span>`,
                    score: reviewsFormat(newParams[i].value),
                    percentage: getPercentageInfo(
                      newParams[i].value,
                      totalReviews,
                      2,
                    ),
                  });
                }
              }

              return formatter({
                title: dataTime,
                tables: [
                  {
                    showHeader: false,
                    records: lineRecords,
                    columns: [
                      {
                        key: 'type',
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'score',
                      },
                    ],
                  },
                  {
                    records: barRecords,
                    columns: [
                      {
                        key: 'type',
                        header: formatMessage({ id: 'Rating' }),
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'score',
                        header: formatMessage({ id: 'Reviews' }),
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'percentage',
                        header: formatMessage({ id: 'Share-1' }),
                      },
                    ],
                  },
                ],
              });
            }}
            filterParams={filterParams}
            platformData={platformData}
            onClick={(params: any) => {
              let start_time = moment(params.name).format('YYYY-MM-DD');
              let end_time = moment(params.name).format('YYYY-MM-DD');

              if (filterParams.date_type === 'weekly') {
                end_time = moment(start_time)
                  .add(6, 'days')
                  .format('YYYY-MM-DD');
              } else if (filterParams.date_type === 'hourly') {
                start_time = moment(params.name).format('YYYY-MM-DD HH:mm:ss');
                end_time = moment(params.name)
                  .endOf('h')
                  .format('YYYY-MM-DD HH:mm:ss');
              }

              const {
                channel_comments,
                channel_social,
                channel_securitys,
                channel_news,
                channel: channelInfo,
                channel_type,
                ...otherFilter
              } = filterParams;
              goStatsDetailAction({
                path: `/opinion/Feeds/Feeds?tab=gameStore`,
                params: {
                  statsDetailType: 'feeds-gameStoreLine',
                  ...otherFilter,
                  start_time,
                  end_time,
                  channel: [platform],
                  channel_type: 'comments',
                },
                history,
                jumpType: JumpType.Window,
              });
            }}
          ></ScoreTrendCharts>
        </div>
      </div>
    </div>
  );
}
